import React from 'react';
import { Button } from '@pwc/pwc-deals-ui';
import { Link } from 'react-router-dom';
import { createHypothesisPath } from '../../common/services/urlService';
import EnableForProjectState from '../security/EnableForProjectState';

const CreateHypothesisLinkButton = ({ projectId, buttonTitle }) => {
  const addHypothesisHref = createHypothesisPath(projectId);

  return (
    <EnableForProjectState projectId={projectId}>
      {({ isProjectDisabled }) => (
        <Link to={!isProjectDisabled && addHypothesisHref}>
          <Button className="mt-3" disabled={isProjectDisabled}>
            {buttonTitle}
          </Button>
        </Link>
      )}
    </EnableForProjectState>
  );
};

export default CreateHypothesisLinkButton;
